import { parentBaseUrl } from "../../url-settings";
import type { CreateClientConfig } from "../api_client/client";

export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  includeCredentials: "include",
  baseUrl: parentBaseUrl,
});
